import { useMemo } from "react";
import { splitScopeByAccountType } from "@/lib/vendor-metric-availability";
import { type Shop, useAuthStore } from "@/stores/auth";

/**
 * Which Sponsored Products attribution windows a set of shops mixes (#671):
 * vendors (1P) are attributed over 14 days, sellers over 7. "vendor" when every
 * shop is a vendor, "mixed" when both kinds are present, null otherwise.
 */
export type AttributionMix = "vendor" | "mixed" | null;

export function attributionMix(
  shops: readonly Pick<Shop, "shopId" | "accountType">[],
  shopIds: readonly string[],
): AttributionMix {
  const { mix } = splitScopeByAccountType(shops, shopIds);
  return mix === "seller" ? null : mix;
}

/** The attribution mix of the given shops, for a performance panel's header note. */
export function useAttributionMix(shopIds: readonly string[] | null | undefined): AttributionMix {
  const shops = useAuthStore((s) => s.shops);
  return useMemo(() => attributionMix(shops, shopIds ?? []), [shops, shopIds]);
}
